import { GoogleTagManager } from '@iwoca/frontend-tracking-library';
import _ from 'lodash';

import * as businessIntroductionSchemasDE from './schema';
import { updateStepData } from '../../actions';

const stepId = 'businessIntroduction';
export function updateStepOneData(dispatch, isValid) {
    dispatch(
        updateStepData({
            id: stepId,
            valid: isValid
        })
    );
}

export function generateFormErrorsFromYup(yupErrors) {
    return {
        company: yupErrors.inner.reduce((errors, error) => {
            const fieldObjectPath = error.path;
            const errorMessage = error.message;
            return _.set(errors, fieldObjectPath, errorMessage);
        }, {})
    };
}

export default (values, dispatch, props) => {
    const yupOptions = {
        abortEarly: false,
        context: {
            onManualCompanySearch: props.ui.manualCompanyName,
            hasSearchResults: props.fetchCompaniesSuccess
        }
    };

    const fieldIdentifier = _.get(props.form, '_asyncValidating');
    const fieldName = _.replace(fieldIdentifier, 'company.', '');

    return businessIntroductionSchemasDE.companyInfoDE
        .validate(values.company, yupOptions)
        .then(() => {
            updateStepOneData(dispatch, true);
            GoogleTagManager.trackFormField({
                formName: stepId,
                fieldName,
                interaction: 'Change'
            });
            return Promise.resolve();
        })
        .catch((errors) => {
            updateStepOneData(dispatch, false);
            GoogleTagManager.trackFormField({
                formName: stepId,
                fieldName,
                interaction: 'Error'
            });
            return Promise.reject(generateFormErrorsFromYup(errors));
        });
};
